export const STOCK_HISTORY_FEATURE_KEY = 'stock-history';
